// The radar tile grid. It lives apart from dopplerRadar.config.js, which reads import.meta.env and
// cannot load in Jest, so a test can check these values.
//
// Each tile is requested one zoom level lower and shown at 512 px. One tile then covers four 256 px
// tiles, so a view needs about a quarter of the requests to the HTTP/1.1 tile server. The radar
// image is softer.
//
// CustomWeather returns empty tiles below zoom 5 for the rows that reach north of 40.98° N: on
// 2026-09-30 every zoom-3 and zoom-4 tile there was empty in every frame, while the zoom-5 tiles
// held the echoes. The radar then stopped at a straight line across Nebraska. minNativeZoom 6 with
// zoomOffset -1 keeps every request at zoom 5 or more. Below map zoom 6, Leaflet shrinks the
// zoom-5 tiles to fit.
export const DOPPLER_TILE_GRID_OPTIONS = Object.freeze({
  tileSize: 512,
  zoomOffset: -1,
  minNativeZoom: 6,
});
